const PLACEHOLDER_COUNT = 5;
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;

let warnedMissingSupabaseUrl = false;

function placeholderUrl(formattedIndex: string): string {
  if (supabaseUrl) {
    return `${supabaseUrl}/storage/v1/object/public/butter-assets/bay_placeholders/bay_${formattedIndex}.jpg`;
  }
  // Placeholder assets now live in Supabase storage, not the public folder, so there
  // is no working fallback. This only happens in local dev with a missing
  // VITE_SUPABASE_URL — warn once (dev only) so the broken images aren't a mystery,
  // and return an empty string rather than a path that's guaranteed to 404.
  if (import.meta.env.DEV && !warnedMissingSupabaseUrl) {
    warnedMissingSupabaseUrl = true;
    console.warn(
      '[bayImage] VITE_SUPABASE_URL is not set — bay placeholder images will not load. ' +
        'Set it in your local env; placeholders are served from Supabase storage.',
    );
  }
  return '';
}

export const generatePlaceholderUrl = (index: number): string => {
  const imgIndex = (index % PLACEHOLDER_COUNT) + 1;
  return placeholderUrl(imgIndex.toString().padStart(3, '0'));
};

export const getRandomPlaceholderUrl = (): string => {
  const randomIndex = Math.floor(Math.random() * PLACEHOLDER_COUNT) + 1;
  return placeholderUrl(randomIndex.toString().padStart(3, '0'));
};

export const getBayImageUrl = (
  bay: { image?: { url?: string } | null },
  index: number
): string => {
  return bay.image?.url || generatePlaceholderUrl(index);
};
